export default __webpack_public_path__ + "static/media/producthunt.83e32b09.svg";